import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import DataTable from 'Settings/components/DataTable';
import NoAliasDataFound from 'Settings/components/NoAliasDataFound/NoAliasDataFound';
import { getAliasList } from 'utils/apiRequests';

function AliasList() {
	const [aliasData, setAliasData] = useState([]);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		getAllDataForAliasList();
	}, []);
	const getAllDataForAliasList = async () => {
		setLoading(true);
		const aliasTableResponse = await getAliasList();
		if (
			aliasTableResponse.errors.Length !== 0 &&
			aliasTableResponse.data !== null
		) {
			setAliasData(aliasTableResponse.data);
		} else {
			console.log('Error Occured');
		}
		setLoading(false);
	};
	if (loading) {
		return <LoadingSpinner visible={loading} message={`Loading`} />;
	}
	if (aliasData.length === 0) {
		return <NoAliasDataFound />;
	}
	return (
		<div style={{ display: 'flex', justifyItems: 'center' }}>
			{' '}
			<DataTable data={aliasData} />
		</div>
	);
}

export default AliasList;
